import type { ReactNode } from "react";
import { ErrorBoundary } from "./ErrorBoundary.js";
import { ThemeStyleInjector } from "./features/theme/ThemeStyleInjector.js";
import { TypographyStyleInjector } from "./features/typography/TypographyStyleInjector.js";

/** Outer shell — just a flex container; routes render inside RouterProvider. */
export function App({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full">
      <ThemeStyleInjector />
      <TypographyStyleInjector />
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
}
